import { Bell, Smartphone } from 'lucide-react';
import { useState } from 'react';
import { usePushStatus } from '../../lib/push';
import { readPref, writePref } from '../../lib/storage';
import { Button, ButtonLink } from '../Button';
import { usePushActions } from './usePushActions';
import styles from './push.module.css';

const DISMISSED = 'push.prompt';

/**
 * A gentle invitation on the calendar to switch reminders on (permission is asked only
 * after the tap). Hidden for good once dismissed or decided.
 */
export function PushPrompt() {
  const [dismissed, setDismissed] = useState(() => readPref(DISMISSED) === 'dismissed');
  const status = usePushStatus();
  const { enable } = usePushActions();
  const state = status.data?.status;
  const undecided = state === 'off' && typeof Notification !== 'undefined' && Notification.permission === 'default';
  if (dismissed || !(undecided || state === 'ios-needs-install')) return null;

  const dismiss = () => {
    writePref(DISMISSED, 'dismissed');
    setDismissed(true);
  };

  return (
    <aside className={styles.prompt} aria-labelledby="push-prompt-title">
      <p className={styles.promptTitle} id="push-prompt-title">
        <Bell aria-hidden="true" className={styles.promptIcon} />
        Przypomnienia o wizytach
      </p>
      <p>
        {state === 'ios-needs-install'
          ? 'Dodaj aplikację do ekranu głównego, a dostaniesz przypomnienie przed każdą wizytą i poranny plan dnia.'
          : 'Dostaniesz przypomnienie przed każdą wizytą i poranny plan dnia.'}
      </p>
      <div className={styles.buttons}>
        {state === 'ios-needs-install' ? (
          <ButtonLink to="/instalacja" variant="primary" size="sm" icon={<Smartphone aria-hidden="true" />}>
            Jak dodać aplikację
          </ButtonLink>
        ) : (
          <Button
            variant="primary"
            size="sm"
            icon={<Bell aria-hidden="true" />}
            disabled={enable.isPending}
            onClick={() => enable.mutate(status.data!.publicKey!, { onSettled: dismiss })}
          >
            Włącz powiadomienia
          </Button>
        )}
        <Button variant="ghost" size="sm" onClick={dismiss}>
          Nie teraz
        </Button>
      </div>
    </aside>
  );
}
